import {IService, SystemComponentType, ComponentModuleViewConfig} from '@gongxigames/framework/core/types';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';
import {SignalEventEmitterWrapper} from '@gongxigames/framework/core/services/strictEventEmitter/SignalEventEmitterWrapper';
import {strictUiEmitter, slotStore, StrictUiEmitterEventMap} from '@gongxigames/framework/slotV2/globals';
import {injectable} from '@gongxigames/framework/core/installer';

@injectable()
export class UiServiceV2<T = StrictUiEmitterEventMap> implements IService {
    public readonly type: SystemComponentType = 'service';

    private readonly abortController = new AbortController();
    protected readonly abortSignal = this.abortController.signal;

    protected readonly emitter = new SignalEventEmitterWrapper(strictUiEmitter, {signal: this.abortSignal, owner: this}) as unknown as SignalEventEmitterWrapper<T>;

    protected readonly store = slotStore;

    public configure<C extends ComponentModuleViewConfig>(config: C): void {
        this.onConfigure(config);
    }

    public init(): void {
        this.onInit();
        this.onSetupEvents();
    }

    public destroy(): void {
        this.abortController.abort();
        this.onDestroy();
        consoleLogger.log(`Module ${this.constructor.name} destroyed`);
    }

    protected onConfigure<C extends ComponentModuleViewConfig>(config: C): void {}
    protected onInit(): void {}
    protected onSetupEvents(): void {}
    protected onDestroy(): void {}
}